var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.687 1.25h7.012l2.52 2.975v6.811l1.531 3.646v1.068H2.25v-1.068l1.531-3.646V4.192zm.626 1.5L5.281 4.808v6.53L4.058 14.25h11.884l-1.223-2.911V4.775L13.004 2.75z",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8 17.25h4v1.5H8z",
    clipRule: "evenodd"
  })));
};
export { SvgBell as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC41IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYuNjg2NTcgMS4yNUgxMy42OTkyTDE2LjIxODggNC4yMjUwOVYxMS4wMzY0TDE3Ljc1IDE0LjY4MjJWMTUuNzVIMi4yNVYxNC42ODIyTDMuNzgxMjUgMTEuMDM2NFY0LjE5MjFMNi42ODY1NyAxLjI1Wk03LjMxMzQzIDIuNzVMNS4yODEyNSA0LjgwNzlWMTEuMzM4Nkw0LjA1ODQ2IDE0LjI1SDE1Ljk0MTVMMTQuNzE4OCAxMS4zMzg2VjQuNzc0OTFMMTMuMDAzOSAyLjc1SDcuMzEzNDNaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTggMTcuMjVIMTJWMTguNzVIOFYxNy4yNVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";